import { render } from "./InfoscreenGR.vue?vue&type=template&id=1ad2ad6c&scoped=true"
import script from "./InfoscreenGR.vue?vue&type=script&lang=js"
export * from "./InfoscreenGR.vue?vue&type=script&lang=js"

import "./InfoscreenGR.vue?vue&type=style&index=0&id=1ad2ad6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ad2ad6c"]])

export default __exports__